import { render, staticRenderFns } from "./robotreply.vue?vue&type=template&id=c667ed6c&scoped=true&"
import script from "./robotreply.vue?vue&type=script&lang=js&"
export * from "./robotreply.vue?vue&type=script&lang=js&"
import style0 from "./robotreply.vue?vue&type=style&index=0&id=c667ed6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c667ed6c",
  null
  
)

export default component.exports